import React, { useRef, useEffect, useState } from 'react'
import Slider from "react-slick";
import axios from 'axios'
import { BsFillArrowLeftCircleFill, BsFillArrowRightCircleFill } from "react-icons/bs";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

import './Placementstats.css'
import PlacementCard from './PlacementCard';
import Loader from '../../Loader/Loader';
import HighlightsCarouselCard from '../HighlightsCarouselCard/HighlightsCarouselCard';

const PLACEMENT_URL = '/placement'
const PLACEMENT_CAROUSEL_URL = '/placement-carousel'

function Placementstats() {
  

  const [placementData, setPlacementData] = useState('')
  const [placeCarousel, setPlaceCarousel] = useState('')
  const [sortedPlaceCarousel, setSortedPlaceCarousel] = useState([])

  const sliderRef = useRef();
    
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    fade: false,
    pauseOnHover: true
  };

  const gotoNext = () => {
    sliderRef.current.slickNext();
  }

  const gotoPrev = () => {
    sliderRef.current.slickPrev();
  }

  useEffect(() => {
    async function getPlacementData() {
      try {
        const response = await axios.get(process.env.REACT_APP_MEC_API + PLACEMENT_URL);
        setPlacementData(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getPlacementData()

    async function getPlaceCarousel() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + PLACEMENT_CAROUSEL_URL);
        setPlaceCarousel(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getPlaceCarousel()
  }, [])

  
  useEffect(() => {
    let sorted = placeCarousel && placeCarousel.sort((a, b) => a.order_no < b.order_no ? -1 : 1)
    setSortedPlaceCarousel(sorted)
  }, [placeCarousel])



  const filteredCarousel = sortedPlaceCarousel && sortedPlaceCarousel.filter(x => x.placement_type === 'placement')
  const csPlacement = placementData && placementData.filter(x => x.no_of_offers.CSE > 0 && x.type_placement === 'placement');
  // const csPlacement = placementData && placementData.filter(x => x.no_of_offers.CSE > 0 && x.type_placement === 'placement' && x.year === year);

  let maxYear = csPlacement && csPlacement.reduce((acc, value) => {
    return (acc = acc > value.year ? acc : value.year);
  }, 0);

  const [year, setYear] = useState(maxYear)

  useEffect(() => {
    setYear(maxYear)
  }, [maxYear])
  
  const previousYear = () => {
    if (year > 2005) {
      setYear(year - 1)
    }
  }
  const nextYear = () => {
    if (year < maxYear)
      setYear(year + 1)
  }

  const csCurrentYear = csPlacement && csPlacement.filter(x => x.year === year)
  

  return (
    <div className='placementstats'>
      <div className='section__container'>
        <div className='section'>
          <h1 className='section__header'>Placement Highlights</h1>
          <div className='highlightsCarousal'>
          <IoIosArrowBack onClick={gotoPrev} className='achSlider__prev'/>
            <div className='highlight__slider'>
                <Slider {...settings} ref={sliderRef}>
                    {filteredCarousel ? filteredCarousel.map((ach) => (
                        <HighlightsCarouselCard 
                          key={ach._id}
                          company_name={ach.company_name}
                          company_website={ach.company_website}
                          image={ach.image && ach.image.url}
                          company_logo={ach.company_logo && ach.company_logo.url}
                          _package={ach.package}
                          placement_type={ach.placement_type}
                          student_batch={ach.student_batch}
                          student_name={ach.student_name}
                          type="PLACEMENT"
                        /> 
                    )) : <Loader color="#AE9142" size={50}/>}
                </Slider>
            </div>
            <IoIosArrowForward onClick={gotoNext} className='achSlider__next'/>
          </div>
        </div>
        <div className='section'>
          <h1 className='section__header'>Placement Statistics</h1>
          <div className='section_slider'>
            <BsFillArrowLeftCircleFill onClick={previousYear} className='slider_btn' style={{opacity: year === 2005 ? 0.5 : 1, cursor: year === 2005 ? 'auto' : 'pointer' }}/>
            <h2>{year}</h2>
            <BsFillArrowRightCircleFill onClick={nextYear} className='slider_btn' style={{opacity: year === maxYear ? 0.5 : 1, cursor: year === maxYear ? 'auto' : 'pointer' }}/>
          </div>
          <div className='placement__container'>
            <div className='placementCard_header'>
              <h3>Sl.no</h3>
              <h3>Recruiters</h3>
              <h3>Offers</h3>
            </div>
            {csCurrentYear ? csCurrentYear.map((comp, id) => (
              <PlacementCard
                id={comp.id}
                key={comp.id}
                slno={id + 1}
                logo={comp.company.logo}
                name={comp.company.name}
                offers={comp.no_of_offers.CSE}
              />
            )) : <Loader color="#AE9142" size={50}/>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Placementstats